import { axiosRoot } from "@/libs/axios";

export function forgotPassword(data) {
  return axiosRoot.post(`/forgot_password/`, data, {});
}
